module.exports = __webpack_public_path__ + "static/media/healthcare.a6e0f740.webp";